
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/agency",
      function () {
        return require("private-next-pages/blockquiry_connect/agency/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blockquiry_connect/agency"])
      });
    }
  